import { format } from 'date-fns';
import { Laptop, LucideIcon, Smartphone } from 'lucide-react';
import { UAParser } from 'my-ua-parser';

interface SessionInfo {
    deviceType: string;
    browser: string;
    os: string;
    timeAgo: string;
    icon: LucideIcon;
}

export const parseSession = (
    userAgent: string,
    createdAt: string,
): SessionInfo => {
    const parser = new UAParser(userAgent);
    const result = parser.getResult();

    const deviceType = result.device.type || 'Desktop';
    const browser = result.browser.name ? `${result.browser.name}` : 'Web';
    const osVersion = userAgent.split(' ')[3].replace(';', '').replace(')', '');
    const os = result.os.name
        ? `${result.os.name} ${result.os.version ?? osVersion}`
        : result.ua;

    // Choose an icon based on device type
    const icon = deviceType === 'mobile' ? Smartphone : Laptop;

    // Format expiration information
    const formattedAt = format(new Date(createdAt), 'EEEE, dd MMM, yyyy, p z');

    return {
        deviceType,
        browser,
        os,
        timeAgo: formattedAt,
        icon,
    };
};
